import React from "react";

// region Imports - Components
import NewDataTable, { DataTableActions, DataTableButtons, DataTableColumns } from "@molecules/NewDataTable";
// endregion Imports - Components
// region Imports - Languages
import { ManagementMessages } from "@shared/languages/interfaces";
// endregion Imports - Languages
// region Imports - Shared / Utils
import { User } from "@shared/interfaces/user.interface";
// endregion Imports - Shared / Utils

interface UserTableProps {
  t: (key: string) => string;
  users: User[];
  loadingUserList: boolean;
  dataTableColumns: DataTableColumns[];
  dataTableSettings: DataTables.Settings;
  dataTableActions: DataTableActions[];
  dataTableButtons: DataTableButtons[];
  setTable: (table: DataTables.Api) => void;
  setTableClickedRow: (row: JQuery<HTMLTableRowElement>) => void;
}
const UserTable: React.FC<UserTableProps> = ({
  t,
  users,
  loadingUserList,
  dataTableColumns,
  dataTableSettings,
  dataTableActions,
  dataTableButtons,
  setTable,
  setTableClickedRow
}) => {
  return (
    <NewDataTable
      title={t(ManagementMessages.dataTableName).toLowerCase()} // Use correct key for "Users" or "User" list title
      data={users}
      filters
      columns={dataTableColumns}
      settings={dataTableSettings}
      actions={dataTableActions}
      buttons={dataTableButtons}
      returnTable={setTable}
      returnClickedRow={setTableClickedRow}
    />
  );
};

export default UserTable;
